/* eslint-disable */
import Dialog from '@mui/material/Dialog'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { Checkbox } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconButton from '@mui/material/IconButton'
import Radio from '@mui/material/Radio'
import { Button } from 'react-bootstrap'
import ApiService from '../ApiService'
import { EMULATOR_CHANGE_SSID_URL, EMULATOR_URL, USER_URL } from '../constants'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: (theme) => theme.palette.blue
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      backgroundColor: '#FFFFFF', // Set dropdown background to white
      fontSize: '12px !important',
      fontFamily: 'Poppins, sans-serif !important',
      color: '#000000', // Text color black
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: '#FFFFFF !important' // Ensure selected item remains white
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: '#F0F0F0 !important' // Light gray on hover
      },
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#FFFFFF'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#A9A9A9',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#A9A9A9'
      }
    }
  }
}

const ChangeEmulatorSsidPopup = (props) => {
  const {
    showToast,
    open,
    handleClose,
    emulatorToChangeSsid,
    handleAssignedUserToEmulator,
    setUpdateSerial
  } = props

  const [emulators, setEmulators] = useState()
  const [selectedUserId, setSelectedUserId] = useState()
  const [generateIdChecked, setGenerateIdChecked] = React.useState(false)

  const handleChangeRadio = (event) => {
    setSelectedUserId(event.target.value)
  }

  const handleGenerateIdChange = (event) => {
    setGenerateIdChecked(event.target.checked)
  }

  const handleSubmitChangeSsid = async () => {
    try {
      const emulatorId = emulatorToChangeSsid.id
      const emulatorSsid = selectedUserId
      const generateRandomNewUuid = generateIdChecked

      const token = localStorage.getItem('token')
      const payload = {
        emulatorId,
        emulatorSsid,
        generateRandomNewUuid
      }
      const { success, data, error } = await ApiService.makeApiCall(
        EMULATOR_CHANGE_SSID_URL,
        'POST',
        payload,
        token
      )
      if (success) {
        showToast('Emulator Updated ', 'success')
        handleClose(data.id, null)
        handleAssignedUserToEmulator(true, null, data)
      } else {
        console.error('Error occurred while adding user:', error)
        showToast('Emulator Not Updated', 'error')
        handleAssignedUserToEmulator(false, 'error occurred', null)
      }
    } catch (error) {
      console.error('Error occurred while adding user:', error)
    }
    setUpdateSerial(true)
  }

  const handleChange = (event) => {
    const {
      target: { value }
    } = event
    console.log('testLog:', value)

    setSelectedUserId(value)
  }

  useEffect(() => {
    // Fetch data from API
    const fetchUsers = async () => {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(USER_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok || response.status !== 200) {
          return { success: false, error: 'Invalid credentials' }
        } else {
          const responseData = await response.text()

          const deserializedData = JSON.parse(responseData)

          setEmulators(deserializedData)
          return { success: true, error: null }
        }
      } catch (error) {
        console.error('User Data Error: ' + error)
      }

      const { success, data, error } = await ApiService.makeApiCall(
        EMULATOR_URL,
        'GET',
        null,
        token
      )
      if (success) {
        setEmulators(data)
        return { success: true, error: null }
      } else {
        console.error('Error Fetching Emulators:', error)
        showToast('Error Fetching Emulators', 'error')
        return { success: false, error: 'Error Fetching Emulators' }
      }
    }
    fetchUsers()
  }, [open, showToast])

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '4px', // Adjust the radius as needed
            width: '484px'
          }
        }}
      >
        <BootstrapDialogTitle
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontWeight: '75px',
            padding: '1rem'
          }}
          className="customized-dialog-title-generate-UUID"
          onClose={handleClose}
        >
          Generate UUID Or Swap/Take from other emulators
        </BootstrapDialogTitle>
        <div>
          <DialogContent
            dividers
            sx={{
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: '#FFFF'
              }
            }}
          >
            <FormControl sx={{ marginTop: '0rem' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={generateIdChecked}
                    onChange={handleGenerateIdChange}
                    sx={{
                      color: '#A3A3A3',
                      '&.Mui-checked': {
                        color: '#2C6FEB'
                      }
                    }}
                  />
                }
                label="Generate new UUID"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontFamily: "'Poppins', sans-serif !important",
                    letterSpacing: '0px !important',
                    color: '#000000 !important',
                    fontSize: '16px'
                  }
                }}
              />
            </FormControl>

            <FormControl className="uuid-dropdown">
              {!generateIdChecked && (
                <>
                  <label className="form-label">
                    <span className="generate-modal-sub-head"> Select Id </span>
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    onChange={handleChange}
                    input={
                      <OutlinedInput
                        label="Name"
                        sx={{
                          backgroundColor: 'white',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ccc' // Default border color
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#A3A3A3' // Border color on hover
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#A3A3A3', // Border color when focused (clicked)
                            borderWidth: '0.1px',
                            boxShadow: '1px 1px 7px 0px #00000017'
                          },
                          '& .MuiSelect-select': {
                            paddingTop: '8px', // Fix top spacing issue
                            paddingBottom: '8px', // Keep consistent height
                            minHeight: 'unset', // Prevent extra height
                            paddingRight: '32px', // Apply padding-right
                            borderTop: '1px solid #858585' // Apply border-top
                          }
                        }}
                      />
                    }
                    MenuProps={MenuProps}
                  >
                    {emulators?.map((emulator) => (
                      <MenuItem
                        key={emulator.emulatorSsid}
                        value={emulator.emulatorSsid}
                        sx={{
                          fontSize: '14px', // Font size
                          fontFamily: 'Poppins, sans-serif !important', // Font family
                          color: '#000000', // Text color (black)
                          backgroundColor: '#FFFFFF', // Background color (white)
                          fontWeight: '400',
                          '&:hover': {
                            backgroundColor: '#F0F0F0' // Light gray on hover
                          }
                        }}
                      >
                        <FormControlLabel
                          value={emulator.emulatorSsid}
                          control={<Radio />}
                          onChange={(e) => handleChangeRadio(e)}
                        />
                        {emulator.id + ' ,' + emulator.emulatorSsid}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  className="global-font w-40 mt-4 rounded-2 py-2 fw-medium ms-0 me-0 uuid-submit"
                  type="submit"
                  onClick={() => handleSubmitChangeSsid()}
                >
                  Submit
                </Button>
              </div>
            </FormControl>
          </DialogContent>
        </div>
      </BootstrapDialog>
    </div>
  )
}
export default ChangeEmulatorSsidPopup
